import { IndicatorLabel } from "@codat/orchard-ui";
import React from "react";

import { integrationIds } from "../../../../utils/constants";
import { ConnectionStatus, SourceType } from "../../Companies";
import ConnectionButton from "../../ConnectionButton/ConnectionButton";
import styles from "../CompaniesTable/CompaniesTable.module.scss";

export type ConnectionsCellModel = {
  key: `connections-${SourceType}`;
  value: {
    type: SourceType;
    onPlatformClick: (id?: string) => void;
    maximumShownConnections: number;
    connections: {
      id: string;
      platformName: string;
      status: ConnectionStatus;
      sourceType: SourceType;
      integrationId: string;
    }[];
    companyId: string;
  };
};

export function ConnectionsCell({
  value,
}: Pick<ConnectionsCellModel, "value">) {
  const isFileUpload = (c: ConnectionsCellModel["value"]["connections"][0]) =>
    c.integrationId !== integrationIds.nCino &&
    (c.integrationId === integrationIds.accountingFileUpload ||
      c.integrationId === integrationIds.bankingFileUpload ||
      c.integrationId === integrationIds.businessDocumentsFileUpload);
  const fileUploadConnections = value.connections.filter(isFileUpload);

  const allConnections = [
    ...value.connections.filter(
      (c) => !isFileUpload(c) && c.integrationId !== integrationIds.nCino
    ),
    ...fileUploadConnections,
  ];

  const additionalConnectionsCount =
    allConnections.length - value.maximumShownConnections > 0
      ? allConnections.length - value.maximumShownConnections
      : 0;

  return (
    <div className={styles.connectionsContainer} data-testid="connections-list">
      {allConnections.slice(0, value.maximumShownConnections).map((c) => (
        <ConnectionButton
          key={c.id}
          connectionId={c.id}
          sourceType={c.sourceType}
          status={c.status}
          type={value.type}
          onPlatformClick={value.onPlatformClick}
          platformName={isFileUpload(c) ? "File upload" : c.platformName}
          companyId={value.companyId}
        />
      ))}
      {additionalConnectionsCount > 0 && (
        <button
          data-testid="additional-connections-count"
          onClick={(e) => {
            e.stopPropagation();
            value.onPlatformClick();
          }}
          className={styles.additionalConnectionsButton}
          aria-label={`${additionalConnectionsCount} other connections`}
        >
          <IndicatorLabel
            label={`+${additionalConnectionsCount}`}
            color="interface"
          />
        </button>
      )}
    </div>
  );
}
